import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { SelectTransformation } from 'app/model/dataflow/selectTransformation';
import { FLOW } from 'app/model/adapters/dataflow/IDataflow';
import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { DataFlowSchemaAdapterUtils } from '../dataflow-schema-adapter-utils';
import { DataFlowExpressionUtils } from '../expression.util';
import { BooleanDataFlowType } from 'app/model/dataflow/dataflow-datatype';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SelectTransformation),
    asynchronous: true
})
export class SelectTransformationAdapter extends TransformationAdapter<SelectTransformation> {
    public async getDslScript(selectTransformation: SelectTransformation): Promise<string> {
        const props: string[] = [];
        const columns = DataFlowSchemaAdapterUtils.getColumnsDsl(selectTransformation);
        const partition = TransformationAdapter.getPartitionDslScript(selectTransformation);

        if (columns) {
            props.push(columns);
        }

        if (partition) {
            props.push(partition);
        }

        props.push(
            `skipDuplicateMapInputs: ${DataFlowExpressionUtils.wrapExpressionConfigValue(
                selectTransformation.skipDuplicateMapInputs,
                BooleanDataFlowType.TYPE
            )}`
        );
        props.push(
            `skipDuplicateMapOutputs: ${DataFlowExpressionUtils.wrapExpressionConfigValue(
                selectTransformation.skipDuplicateMapOutputs,
                BooleanDataFlowType.TYPE
            )}`
        );

        const knownProps = props.filter((prop) => !!prop).join(',\n\t');
        const unknownProps = this._getUnknownProps(selectTransformation, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');

        return (
            `${this._getInputStreams(selectTransformation)} ${SelectTransformation.MODEL.name}` +
            `(${transformationData}) ${FLOW} ${this._getOutputStreams(selectTransformation)}`
        );
    }
}
